<!-- <rg-gauge-chart
matTooltip=" Velocity Thresholds as per ISO 10816-3 or customer defined specific thresholds as per their process."
style="color: orange;color:black;"
[matTooltipClass]="'tooltip'"
[ngClass]="'custom-css'"
[canvasWidth]="160"
[needleValue]="inputData[0].needleValue"
[needleColor]="inputData[0].options.needleColor"
[options]="inputData[0].options"
[name]=""
[bottomLabel]="inputData[0].bottomLabel">
</rg-gauge-chart>  -->

<div *ngIf="loading; else gaugeChart" class="spinner-container">
  <div class="spinner-border text-primary" role="status"></div>
</div>

<ng-template #gaugeChart>
  <app-gauge-chart
    style="color: orange; color: black"
    [ngClass]="'custom-css'"
    [canvasWidth]="160"
    [canvasHeight]="140"
    [needleValue]="inputData[0]?.needleValue"
    [needleColor]="inputData[0]?.options.needleColor"
    [options]="inputData[0]?.options"
    [name]=""
    [bottomLabel]="inputData[0]?.bottomLabel"
  >
  </app-gauge-chart>
</ng-template>
